import { TValidator } from "../../../wizard/types";

const validator: TValidator = async ({ values }) => {
  const errors: { [key: string]: any } = {};

  if (!values.reason?.trim()) {
    errors.reason = "Reason is required";
  }

  if (Object.keys(errors).length > 0) {
    throw errors;
  }
};

export default validator;
